import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "overlay", "blockLabel", "usersContainer", "emptyState"]

  open(event) {
    event.preventDefault()

    const { label, users } = event.currentTarget.dataset
    const usersData = JSON.parse(users || "[]")

    this.blockLabelTarget.textContent = label
    this.usersContainerTarget.innerHTML = ""

    if (usersData.length > 0) {
      usersData.forEach(user => {
        const item = document.createElement("li")
        item.className = "rounded-lg bg-white px-3 py-2 text-sm font-medium text-gray-900 shadow-sm"
        item.textContent = user.name
        this.usersContainerTarget.appendChild(item)
      })

      this.usersContainerTarget.classList.remove("hidden")
      this.emptyStateTarget.classList.add("hidden")
    } else {
      this.usersContainerTarget.classList.add("hidden")
      this.emptyStateTarget.classList.remove("hidden")
    }

    this.modalTarget.classList.remove("hidden")
    document.body.style.overflow = "hidden"
  }

  close() {
    this.modalTarget.classList.add("hidden")
    document.body.style.overflow = ""
  }

  closeOnOverlay(event) {
    if (event.target === this.overlayTarget) {
      this.close()
    }
  }

  closeOnEscape(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }
}
